export default class Frequencia {
    
    constructor(model = null){
        this.id = 0;
        this.empresaId = 0;
        this.data = '';
        this.projetoId = 0;
        this.beneficiarioId = 0;
        this.situacao = 'P';
        this.situacaoStr = 'PRESENÇA';
        this.observacao = '';

        if (!model)
            return;

        this.id = model.id ? model.id : 0;
        this.empresaId = model.empresaId;
        this.data = new Date(model.data).yyyymmdd();
        this.projetoId = model.projetoId;
        this.projeto = model.projeto;
        this.beneficiarioId = model.beneficiarioId;
        this.beneficiario = model.beneficiario;
        this.situacao = model.situacao;
        this.situacaoStr = model.situacaoStr;
        this.observacao = model.observacao;

    }
}